module.exports = __webpack_public_path__ + "static/dash-1-7e8a151113f95ae7ebd6473f656fddef.png";